import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.875 5.625V13.125C1.875 14.1562 2.71875 15 3.75 15H11.25C12.2812 15 13.125 14.1562 13.125 13.125V5.625H1.875Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.25 2.8125V0.9375C11.25 0.375 10.875 0 10.3125 0H4.6875C4.125 0 3.75 0.375 3.75 0.9375V2.8125H0V4.6875H15V2.8125H11.25ZM9.375 2.8125H5.625V1.875H9.375V2.8125Z",
		fill: "currentColor"
	})]
});
export default SvgIconTrash;
